module.exports = __webpack_public_path__ + "static/IHK-Da-logo4c-freigestellt-9754a465e8cd1f9a5a486b421dae3c60.png";